import type { ButtonSelectionTranscriptComponent } from './types';

// Both transcript viewers must use the recorded selection rather than assuming
// it appeared in the offered menu or still has the menu's historical label.
export const getButtonSelectionOptions = (
  component: ButtonSelectionTranscriptComponent,
): ButtonSelectionTranscriptComponent['options'] => {
  const selectedOption = component.options.find(
    option => option.value === component.option_selected,
  );
  const selection = {
    label:
      component.option_selected_label ??
      selectedOption?.label ??
      component.option_selected,
    value: component.option_selected,
  };
  if (component.from_initial_intent_id) {
    return [selection];
  }
  const options = component.options.map(option =>
    option.value === component.option_selected ? selection : option,
  );
  return selectedOption ? options : [...options, selection];
};
